export default class FirebasePdfService {
    getPdfUrl = (url: string): string => {
        return process.env.REACT_APP_API_ENTRYPOINT+"/firebase/pdf?url="+encodeURIComponent(url);
    }
}